import { styled } from 'styled-components'

export const LazyImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const LazyImageObject = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
  object-fit: cover;
`

export const LazyImagePlaceholder = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: cover;
`
